module.exports = __webpack_public_path__ + "img/dodge.834164c4.png";